import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

/** In-app notifications for the logged-in user (overdue report alerts, etc.). */
export const getNotifications = createAsyncThunk(
  'reports/getNotifications',
  async (_: void, { rejectWithValue }) => {
    try {
      const res = await fetch(REPORTS.GET_NOTIFICATIONS, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch notifications');
      }
      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
